/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';

export const bookmarkItemSchema = z.object({
  challengeId: z.number(),
  slug: z.string(),
  title: z.string(),
  type: z.string(),
  cefrLevel: z.string(),
});

export interface IBookmarkItem {
  challengeId: number;
  slug: string;
  title: string;
  type: string;
  cefrLevel: string;
}

const bookmarksDataSchema = z.object({
  items: z.array(bookmarkItemSchema),
  nextCursor: z.string().nullable(),
});

export interface IBookmarksData {
  items: IBookmarkItem[];
  nextCursor: string | null;
}

export const getMyBookmarksV1ResponseSchema = createApiResponseSchema(
  bookmarksDataSchema,
) as z.ZodSchema<IAPI<IBookmarksData>>;

export type IGetMyBookmarksV1Response = IAPI<IBookmarksData>;
